import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ArchiveConversations from './conversations';
import ActiveConversations from './ongoingconversations';
import Index from './tickets/index';
import QuickreplyPage from './quickreply';
import FormTickets from './tickets/FormTickets';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/archives`} component={ArchiveConversations} />
      <Route path={`${match.url}/active`} component={ActiveConversations} />
      <Route
        path={`${match.url}/missingresponse`}
        key="edit-client"
        component={Index}
      />
      <Route path={`${match.url}/tickets`} key="add-client" component={Index} />
      <Route path={`${match.url}/replytemplates`} component={QuickreplyPage} />
      <Route path={`${match.url}/form-ticket`} component={FormTickets} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
